import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { growthApi } from '../api/phase12Client';

export function ModelEquationsPage() {
  const [eq, setEq] = useState<any>(null);
  const [el, setEl] = useState<any>(null);
  const [err, setErr] = useState<string | null>(null);
  useEffect(() => {
    Promise.all([growthApi.equations(), growthApi.elasticities()]).then(([a, b]) => { setEq(a); setEl(b); }).catch((e) => setErr(String(e)));
  }, []);
  if (err) return <div className="error">{err}</div>;
  if (!eq || !el) return <div className="loading">Loading model library…</div>;
  const blocks: string[] = Object.keys(eq.blocks);
  return (
    <div>
      <h1 className="page-title">Model Equations, Elasticities & Rationale</h1>
      <p className="page-subtitle">Everything the dashboard computes, in one place: transmission formulas, the workbook Model 2 port, core macro relations (Solow, Thirlwall, debt dynamics, Okun, Phillips), the stochastic SDE and Fokker–Planck PDE, the reduced-form G-Cubed block, and every elasticity with its source.</p>
      <div className="card">
        <h3>How the pieces fit</h3>
        <div className="eq">{`Policy levers (score 0–4 or value)  ──►  Transmission (C_i = shock·β·m·w·p  |  Q/4·G_max·m·w·p)  ──►  Σ + interactions  ──►  unconstrained g
        │                                                                                                    │
        ├─ Indicator linkage chain (sub-indicator → priority indicator → core variable → GDP; elasticities)  ▼
        ├─ Policy equilibrium chain (energy → industry → exports → fiscal)                      Macro constraints: BOP ceiling (Thirlwall), inflation penalty
        ├─ Workbook Model 2 (2024–2031 GDP / revenue / employment / tariff blocks)                            ▼
        └─ Signature programmes (construction multiplier + infrastructure-stock elasticity)          simulated g  ──►  SDE Monte Carlo + Fokker–Planck fan chart
                                                                                                           ──►  Target Tracer (reverse allocation), Chief Economist`}</div>
      </div>
      {eq.workbook_unit_notes?.length > 0 && <div className="card" style={{ borderLeft: '4px solid #F59E0B' }}><h3>Workbook unit corrections</h3>{eq.workbook_unit_notes.map((n: string, i: number) => <div key={i} className="small" style={{ marginBottom: 6 }}>• {n}</div>)}</div>}
      {blocks.map((bk) => (
        <div className="card" key={bk}>
          <h3>{bk}</h3>
          {eq.blocks[bk].map((e: any) => (
            <div key={e.id} style={{ marginBottom: '1rem' }}>
              <strong>{e.name}</strong> <span className="small">({e.id}{e.used_in ? ` · used in: ${e.used_in}` : ''})</span>
              <div className="eq">{e.equation}</div>
              {e.variables && <div className="small"><strong>Variables:</strong> {e.variables}</div>}
              {e.parameters && <div className="small"><strong>Parameters:</strong> {e.parameters}</div>}
              {e.rationale && <div style={{ fontSize: '0.85rem', marginTop: 4 }}>{e.rationale}</div>}
              {e.reference && <div className="small"><em>{e.reference}</em></div>}
            </div>))}
        </div>))}
      <div className="card">
        <h3>Elasticities, evidence and linkages</h3>
        <p className="small">The full register of {el.workbook_and_literature.length} elasticities, {el.model_evidence.length} evidence items and {el.indicator_linkages.length} indicator linkages, together with every structural assumption, is on the <Link to="/assumptions">Assumptions & Elasticities Register</Link> tab.</p>
      </div>
    </div>
  );
}
